<template>
  <div id="app">
 <main>
      <transition mode="out-in">
       <router-view />
      </transition>
    </main>    
  </div>
</template>

<script>
export default {
  created() {
      document.title = "Signature Genaration - Focus Química";
  },
};
</script>
<style src="@/scss/main.scss" lang="scss" />
